import { loadingSpinner } from "../helpers";

class ProductCard extends HTMLElement {
  constructor(options) {
    super();

    this.options = Object.assign(
      {
        selectors: {
          variantSelector: ".product-card__selector input",
          selectedVariant: "select#js-selected-variant",
          optionSelectors: ".product-card__selector",
          primaryImage: ".primary-image",
          secondaryImage: ".secondary-image",
        },
        texts: {
          soldOut: "Sold out",
        },
      },
      options
    );

    this.s = this.options.selectors;
    this.t = this.options.texts;

    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", this.onSubmitHandler);
    }

    this.quantityInput = this.querySelector(".js-quantity-input");
    this.init();
  }

  init() {
    this.initSelect();
  }

  initSelect() {
    this.querySelectorAll(this.s.variantSelector).forEach((el) => {
      el.addEventListener("change", (e) => {
        var values = [];
        var variant = "";
        var value = this.getOptionValues(values);
        var variant_selector = this.querySelector(this.s.selectedVariant);

        for (var i = 0; i < value.length; i++) {
          if (i == 0) {
            variant = value[i];
          } else {
            variant = variant + " / " + value[i];
          }
        }

        this.changeVariant(variant, variant_selector);
        this.fetchVariantImage(variant_selector);
      });
    });
  }

  getOptionValues(values) {
    var optionSelectors = this.querySelectorAll(this.s.optionSelectors);

    optionSelectors.forEach(function (selector, index) {
      if (index == 0) {
        let option = selector.querySelector("input:checked");
        values.push(option.value);
      } else {
        let options = selector.querySelectorAll("input");
        options.forEach(function (option, index) {
          if (!option.hasAttribute("checked")) return;

          values.push(option.value);
        });
      }
    });

    return values;
  }

  changeVariant(variant, variant_selector) {
    variant_selector.querySelectorAll("option").forEach(function (option) {
      var text = option.innerText.trim();
      if (text.indexOf(variant) === -1) return;

      let value = option.value;
      if (typeof value != "undefined") {
        variant_selector.value = value;
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        variant_selector.dispatchEvent(evt);
      }
    });
  }

  fetchVariantImage(variant) {
    let handle = variant.dataset.productHandle;

    window
      .fetch(window.Shopify.routes.root + `products/${handle}.js`, {
        method: "GET",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.json())
      .then((r) => {
        //
        this.changeVariantImage(r, variant);
        this.changeAddToCartCTA(r, variant);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  changeVariantImage(r, variant) {
    let id = parseInt(variant.value);
    let selectedVariant = r.variants.find((obj) => obj.id === id);

    if (selectedVariant.featured_image == null) return;

    let variantImage = selectedVariant.featured_image.src;
    let primaryImage = this.querySelector(this.s.primaryImage);
    let secondaryImage = this.querySelector(this.s.secondaryImage);

    primaryImage.srcset = variantImage;
    if (secondaryImage != null) {
      secondaryImage.srcset = variantImage;
    }
  }

  changeAddToCartCTA(r, variant) {
    let id = parseInt(variant.value);
    let selectedVariant = r.variants.find((obj) => obj.id === id);

    if (!selectedVariant.available) {
      let addToCart = this.querySelector(".product-card__button");
      addToCart.value = this.t.soldOut;
      addToCart.classList.add("disabled");
      addToCart.disabled = true;
    } else {
      let addToCart = this.querySelector(".product-card__button");
      addToCart.value = "Add to cart";
      addToCart.classList.remove("disabled");
      addToCart.disabled = false;
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    const spinner = submitButton.querySelector(".loading-overlay__spinner");
    const addedIcon = submitButton.querySelector(".added-icon");
    const atcIcon = submitButton.querySelector(".add-icon");
    const productID = submitButton.dataset.id;
    this.currentQty = this.querySelector(".quantity__input").value;
    if (spinner) spinner.classList.remove("hidden");
    submitButton.classList.add("loading");

    const body = {
      items: [
        {
          id: productID,
          quantity: this.currentQty,
        },
      ],
    };

    const options = {
      firstCallback: function (requestState) {
        submitButton.classList.add("loading");
      },
      lastCallback: function (requestState) {
        setTimeout(() => {
          spinner?.classList.add("hidden");
          atcIcon?.classList.add("hidden");
          submitButton.classList.remove("loading");
          if (requestState.responseData.status === 200) {
            spinner?.classList.add("hidden");
            addedIcon?.classList.remove("hidden");
            submitButton.querySelector("span").innerText =
              window.Moonbase.locales.products.product.added_to_cart;
          } else {
            submitButton.querySelector("span").innerText =
              window.Moonbase.locales.products.product.error_message;
          }
        }, 2000);
        setTimeout(() => {
          submitButton.querySelector("span").innerText =
            window.Moonbase.locales.products.product.add_to_cart;
          atcIcon?.classList.remove("hidden");
          addedIcon?.classList.add("hidden");
        }, 5000);
      },
      important: false,
    };

    window.liquidAjaxCart.add(body, options);
  }
}

customElements.define("product-card", ProductCard);
